export { talkScriptResource as talkScript } from './talkScript';
export { scenarioResource as scenario } from './scenario';
export { tagResource as tag } from './tag';


// WEBPACK FOOTER //
// ./src/common/dataResourceFactory/index.js